import { useMemo } from 'react';
import moment from 'moment-timezone';
import { getLocaleWeekStartsOn } from '@s20/common/util/date';
import createWeekStartLocalizer from '@s20/common/util/weekStartLocalizer';
import { useTranslation } from '@s20/i18n';
import { getWeekStartsOn } from '@s20/selectors/features/common.selectors';
import { useSelector } from './redux.hooks';

/** The tenant "Week starts on" day as a number 0-6 (0 = Sunday); Monday when the tenant has no setting. */
export const useWeekStartsOn = (): number => useSelector(getWeekStartsOn);

/**
 * The first column of the calendar grids: the active language's week start (Sunday for English, Monday for
 * Spanish), re-read when the language changes. Not the tenant setting: use `useWeekStartsOn` for anything that
 * becomes a job week or a pay week.
 */
export const useCalendarWeekStartsOn = (): number => {
    const { i18n } = useTranslation();

    return useMemo(() => getLocaleWeekStartsOn(), [i18n.language]);
};

/** A react-big-calendar localizer whose grid starts on the language's first day of the week. */
export const useCalendarLocalizer = () => {
    const weekStartsOn = useCalendarWeekStartsOn();

    return useMemo(() => createWeekStartLocalizer(moment, weekStartsOn), [weekStartsOn]);
};
